import {StateCreator} from 'zustand'
import {TGeoMarker} from '../types/geoMarker.types'

type State = {
  geoMarkers: (TGeoMarker | null)[]
}
type Action = {
  setGeoMarkers: (geoMarkers: (TGeoMarker | null)[]) => void
}

export type GeoMarkerSlice = State & Action

const createGeoMarkerSlice: StateCreator<GeoMarkerSlice> = set => ({
  geoMarkers: [],
  setGeoMarkers: geoMarkers => set({geoMarkers: geoMarkers}),
})

export default createGeoMarkerSlice
